import { WheelDetailsModel, _data } from './data.tyre.js';

let WheelDetailsPanel = function () {
    // -------------------------------------------------------------------------------
    //  Private members
    // -------------------------------------------------------------------------------
    let toggleLine = function ($elementToToggle, flag) {
        $elementToToggle.find('input:radio').prop('checked', false);
        if (flag === 'show') {
            $elementToToggle.css('display', 'flex');
        } else if (flag === 'hide') {
            $elementToToggle.css('display', 'none');
        }
    };
    let bindControls = function () {
        $('input[name="WheelType"]').on('change', function (e) {
            e.preventDefault();
            toggleLine($('#wheelDetailsSection .form-group:not(.first)'), 'hide');
            var selectedValue = $(this).filter(':checked').val();
            if (selectedValue === 'Steel') {
                toggleLine($(this).closest('.form-group').nextAll().not('.lockingNutsRow').first(), 'show');
            } else if (selectedValue === 'Alloy') {
                toggleLine($('.lockingNutsRow'), 'show');
            }
        });
        $('input[name="LockingWheelNuts"]').on('change', function () {
            const hasLockingNuts = $(this).filter(':checked').val();
            const toggleWheelNutMessages = togglePropArray => {
                togglePropArray.forEach(element => {
                    toggleLine($(element.id), element.style);
                });
            };

            switch (hasLockingNuts) {
                case 'Yes': toggleWheelNutMessages([{id: '#wheelNutsWarning', style: 'hide'}, {id: '#wheelNutsInfo', style: 'show'}]);                
                    break;
                case 'No': toggleWheelNutMessages([{id: '#wheelNutsWarning', style: 'hide'}, {id: '#wheelNutsInfo', style: 'hide'}]);
                    break;
                case 'Unknown':toggleWheelNutMessages([{id: '#wheelNutsWarning', style: 'show'}, {id: '#wheelNutsInfo', style: 'hide'}]);
                    break;
            }
			
            toggleLine($(this).closest('.form-group').next(), 'show');
        });
        $('input[name="RoadworthySpare"]').on('change', function (e) {
            e.preventDefault();
            var selectedValue = $(this).filter(':checked').val();
			if (selectedValue === 'No') {
				toggleLine($('.spareSizeRow'), 'hide');
                toggleLine($('.inflationKitRow'), 'show');
			} else {
				toggleLine($('.spareSizeRow'), 'show');
				toggleLine($('.inflationKitRow'), 'hide');
            }
        });
        $('input[name="SpareSize"], input[name="InflationKit"]').on('change', function (e) {
            e.preventDefault();
            toggleLine($(this).closest('.form-group').nextAll().not('.spareSizeRow').not('.inflationKitRow').first(), 'show');
        });
        $('input[name="ObstructionTyres"]').on('change', function (e) {
            e.preventDefault();
            var selectedValue = $(this).filter(':checked').val();
			if (selectedValue === 'No') {
				toggleLine($('.obstructionDetailsRow'), 'hide');
            } else {
				toggleLine($('.obstructionDetailsRow'), 'show');
            }
        });
    };

    // -------------------------------------------------------------------------------
    //  Public members
    // -------------------------------------------------------------------------------

    return {
        initializePanel: function () {
            bindControls();
        },
        saveWheelDetails: function () {
            let $currentPanel = $('#wheelDetailsSection');

            var wheelDetailsModel = new WheelDetailsModel(
                $currentPanel.find('input[name="WheelType"]:checked').val(),
                $currentPanel.find('input[name="RoadworthySpare"]:checked').val(),
                $currentPanel.find('input[name="SpareSize"]:checked').val(),
                $currentPanel.find('input[name="InflationKit"]:checked').val(),
                $currentPanel.find('input[name="LockingWheelNuts"]:checked').val(),
                $currentPanel.find('input[name="ObstructionTyres"]:checked').val(),
                $currentPanel.find('#obstructionDetails').val()
            );

            _data.vehicle.wheelDetails = wheelDetailsModel;
        },
        getValidator: function () {
            var $roadworthySpareInput;
            var $obstructionInput;
            return $('#wheelDetailsSection').kendoValidator({
                rules: {
                    wheelTypeSelected: function (input) {
                        // Make sure wheelType is selected
                        if ($(input).is('input[name="WheelType"]')) {
                            var $wheelTypeInput = $('input[name="WheelType"]');
                            if (!$wheelTypeInput.is(':checked')) {
                                return false;
                            };
                        };
                        return true;
                    },
                    wheelNutSelected: function (input) {
                        // If Alloy wheel type is selected make sure wheel nut is selected
                        if ($(input).is('input[name="LockingWheelNuts"]') && $('input[name="WheelType"]').is(':checked')) {
                            if ($('input[name="WheelType"]').filter(':checked').val() === 'alloy') {
                                var $wheelnutsInput = $('input[name="LockingWheelNuts"]');
                                if (!$wheelnutsInput.is(':checked')) {
                                    return false;
                                };
                            };
                        };
                        return true;
                    },
                    roadWorthySpareSelected: function (input) {
                        if ($(input).is('input[name="RoadworthySpare"]')) {
                            $roadworthySpareInput = $('input[name="RoadworthySpare"]');
                            if (!$roadworthySpareInput.is(':checked')) {
                                return false;
                            };
                        };
                        return true;
                    },
                    spareSizeSelected: function (input) {
                        // If RoadworthySpare is Yes then spare size should be selected
                        if ($(input).is('input[name="SpareSize"]') && $('input[name="RoadworthySpare"]').is(':checked')) {
                            if ($roadworthySpareInput.filter(':checked').val() === 'true') {
                                var $SpareSizeInput = $('input[name="SpareSize"]');
                                if (!$SpareSizeInput.is(':checked')) {
                                    return false;
                                };
                            }
                        }
                        return true;
                    },
                    inflationKitSelected: function (input) {
                        if ($(input).is('input[name="InflationKit"]') && $('input[name="RoadworthySpare"]').is(':checked')) {
                            if ($roadworthySpareInput.filter(':checked').val() === 'false') {
                                var $inflationKitInput = $('input[name="InflationKit"]');
                                if (!$inflationKitInput.is(':checked')) {
                                    return false;
                                };
                            }
                        }
                        return true;
                    },
                    obstructionSelected: function (input) {
                        // Make sure obstruction on tyre is selected
                        if ($(input).is('input[name="ObstructionTyres"]')) {
                            $obstructionInput = $('input[name="ObstructionTyres"]');
                            if (!$obstructionInput.is(':checked')) {
                                return false;
                            };
                        }
                        return true;
                    },
                    obstructionDetailsSelected: function (input) {
                        if ($(input).is('#obstructionDetails') && $('input[name="ObstructionTyres"]').is(':checked')) {
                            if ($obstructionInput.filter(':checked').val() === 'true') {
                                var $obstructionDetailInput = $('#obstructionDetails');
                                if ($obstructionDetailInput.val().length < 1) {
                                    return false;
                                };
                            };
                        }
                        return true;
                    }
                },
                messages: {
                    wheelTypeSelected: 'Wheel type field is mandatory',
                    wheelNutSelected: 'Wheel nut field is mandatory',
                    roadWorthySpareSelected: 'Roadworthy spare field is mandatory',
                    spareSizeSelected: 'Spare size field is mandatory',
                    inflationKitSelected: 'Inflation kit field is mandatory',
                    obstructionSelected: 'Obstructions field is mandatory',
                    obstructionDetailsSelected: 'Obstruction details field is mandatory'
                }
            }).data('kendoValidator');
        }
    };
};

export let _wheelDetailsPanel = new WheelDetailsPanel();
